import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Heart, ArrowUpRight } from "lucide-react";

export default function Favorites() {
  const [favs, setFavs] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get("/favorites").then((r) => setFavs(r.data.favorites || [])).finally(() => setLoading(false));
  };
  useEffect(load, []);

  const remove = async (styleId) => {
    await api.delete(`/favorites/${styleId}`);
    load();
  };

  return (
    <main className="crown-container py-12 md:py-16" data-testid="favorites-page">
      <p className="font-overline mb-3">Saved</p>
      <h1 className="font-serif text-4xl sm:text-5xl mb-10">Your private archive.</h1>
      {loading ? (
        <p className="font-overline text-ash">Loading…</p>
      ) : favs.length === 0 ? (
        <div className="text-center py-20 border border-bone/10" data-testid="favorites-empty">
          <Heart className="text-gold mx-auto mb-4" strokeWidth={1.5} />
          <p className="font-overline text-ash">No favorites yet.</p>
          <Link to="/gallery" className="crown-btn-ghost mt-6 inline-flex">
            Browse the gallery <ArrowUpRight size={14} strokeWidth={1.5} />
          </Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {favs.map((f) => (
            <div key={f.id} className="group relative aspect-[3/4] overflow-hidden" data-testid={`favorite-${f.style_id}`}>
              <Link to={`/style/${f.style_id}`}>
                <img src={f.style?.image_url} alt={f.style?.name} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-espresso/85 to-transparent" />
                <div className="absolute bottom-4 left-4 right-4">
                  <p className="font-overline text-gold text-[0.65rem]">{f.style?.category}</p>
                  <p className="font-serif text-xl mt-1">{f.style?.name}</p>
                </div>
              </Link>
              <button
                onClick={(e) => { e.preventDefault(); remove(f.style_id); }}
                className="absolute top-3 right-3 bg-espresso/80 backdrop-blur p-2 hover:bg-gold hover:text-espresso transition-colors"
                data-testid={`favorite-remove-${f.style_id}`}
              >
                <Heart size={14} fill="currentColor" strokeWidth={1.5} />
              </button>
            </div>
          ))}
        </div>
      )}
    </main>
  );
}
